<template>
  <div class="attribute-group form-group col-12">
    <label>{{ $t("Choose theme") }} </label>
    <div class="product-attributes types">
      <SwiperLayout
        id="lover-types"
        @changed-slide="updatedLoverType"
        :index="product.attribute_values.loverType.index"
      >
        <SwiperSlide
          v-for="attributeValue in attributes.loverType.attribute_values"
        >
          <div class="attribute">
            <div
              class="image"
              :style="{
                backgroundImage: `url(${attributeValue.preferences.imageUrl})`,
              }"
            ></div>
          </div>
        </SwiperSlide>
      </SwiperLayout>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { SwiperSlide } from "swiper/vue";
import SwiperLayout from "../../../../packages/views/carousel/Layout";
import useLover from "../../useLover";

export default {
  components: {
    SwiperSlide,
    SwiperLayout,
  },
  computed: {
    ...mapGetters({
      attributes: "product/getAttributes",
      product: "product/getProduct",
    }),
  },
  setup() {
    const { updatedLoverType } = useLover()

    return {
      updatedLoverType,
    };
  },
};
</script>
